import api from "./api";

export const fetchDriverById =
    async (driverId) => {
        try {
            const response =
                await api.get(
                    `/driver-management/drivers/${driverId}`
                );

            return {
                success: true,
                data:
                    response.data
                        .data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error
                        ?.response
                        ?.data
                        ?.detail ||
                    "Failed to fetch driver information.",
            };
        }
    };

export const registerDriverForUser =
    async (
        userId,
        payload
    ) => {
        try {
            const formData =
                new FormData();

            formData.append(
                "user_id",
                userId
            );

            formData.append(
                "license_number",
                payload.license_number
            );

            formData.append(
                "license_expiry_date",
                payload.license_expiry_date
            );

            formData.append(
                "route_preference",
                payload.route_preference
            );

            formData.append(
                "package_preference",
                payload.package_preference
            );

            formData.append(
                "driver_license",
                payload.driver_license[0]
                    ?.file
            );

            formData.append(
                "criminal_record",
                payload.criminal_record[0]
                    ?.file
            );

            formData.append(
                "identity_proof",
                payload.identity_proof[0]
                    ?.file
            );

            formData.append(
                "police_affidavit",
                payload.police_affidavit[0]
                    ?.file
            );

            formData.append(
                "residential_address_proof",
                payload
                    .residential_address_proof[0]
                    ?.file
            );

            formData.append(
                "profile_image",
                payload.profile_image[0]
                    ?.file
            );

            const response =
                await api.post(
                    "/driver-management/drivers/register-for-user",
                    formData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };

export const updateDriverForPartner =
    async (
        driverId,
        payload
    ) => {
        try {
            const formData =
                new FormData();

            if (
                payload.license_number !==
                undefined
            ) {
                formData.append(
                    "license_number",
                    payload.license_number
                );
            }

            if (
                payload.license_expiry_date !==
                undefined
            ) {
                formData.append(
                    "license_expiry_date",
                    payload.license_expiry_date
                );
            }

            if (
                payload.route_preference !==
                undefined
            ) {
                formData.append(
                    "route_preference",
                    payload.route_preference
                );
            }

            if (
                payload.package_preference !==
                undefined
            ) {
                formData.append(
                    "package_preference",
                    payload.package_preference
                );
            }

            if (
                payload.driver_license?.[0]
                    ?.file
            ) {
                formData.append(
                    "driver_license",
                    payload.driver_license[0].file
                );
            }

            if (
                payload.criminal_record?.[0]
                    ?.file
            ) {
                formData.append(
                    "criminal_record",
                    payload.criminal_record[0].file
                );
            }

            if (
                payload.identity_proof?.[0]
                    ?.file
            ) {
                formData.append(
                    "identity_proof",
                    payload.identity_proof[0].file
                );
            }

            if (
                payload.police_affidavit?.[0]
                    ?.file
            ) {
                formData.append(
                    "police_affidavit",
                    payload.police_affidavit[0].file
                );
            }

            if (
                payload.residential_address_proof?.[0]
                    ?.file
            ) {
                formData.append(
                    "residential_address_proof",
                    payload.residential_address_proof[0].file
                );
            }

            if (
                payload.profile_image?.[0]
                    ?.file
            ) {
                formData.append(
                    "profile_image",
                    payload.profile_image[0].file
                );
            }

            const response =
                await api.put(
                    `/driver-management/drivers/${driverId}/update-for-partner`,
                    formData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error?.response?.data?.detail ||
                    error?.message ||
                    "Failed to update driver information.",
            };
        }
    };